import { Client } from '@/utilities/api/Client';
import { TwilioConfigEndpoint } from "@api/endpoints/TwilioConfigEndpoint";
import { IntegrationEndpoint } from "@api/endpoints";

export class TwilioConfigApi {
  static getByRetailerId (retailerId: string): Promise<TwilioConfigEndpoint.Get.Response> {
    return Client(`retailers/${retailerId}/twilio-client-config`);
  }

  static createForRetailer (
    retailerId: string,
    body: TwilioConfigEndpoint.Create.Request,
  ): Promise<TwilioConfigEndpoint.Create.Response> {
    return Client(`retailers/${retailerId}/twilio-client-config`, { body, method: 'POST' });
  }

  static exists (retailerId: string): Promise<boolean> {
    return Client(`retailers/${retailerId}/has-twilio-client-config`);
  }

  static update (
    id: string,
    body: TwilioConfigEndpoint.Update.Request,
  ): Promise<IntegrationEndpoint.Create.Response> {
    return Client(
      `twilio-client-config/${id}`,
      { body, method: 'PATCH' },
    );
  }
}
